import * as echarts from "echarts"
import EChartsController from "../echarts_controller"
import { world, countries } from "../world_topology"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
  }

  initialize() {
    echarts.registerMap("world", world)
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    const validCountryCodes = new Set(countries.map((c) => c.code))
    const validIdentifierCountries = this.dataValue.filter(
      (identifierCountries) =>
        validCountryCodes.has(identifierCountries.country_code),
    )
    const validIdentifierCountriesWithName = validIdentifierCountries.map(
      (identifierCountries) => {
        const { name } = countries.find(
          (c) => c.code === identifierCountries.country_code,
        )

        return {
          ...identifierCountries,
          name,
        }
      },
    )

    this.renderChart(this.chart, validIdentifierCountriesWithName)
  }

  renderChart(chart, identifierCountries) {
    chart.setOption({
      geo: {
        type: "map",
        map: "world",
        regions: identifierCountries.map(({ name }) => ({
          name: name,
          itemStyle: {
            areaColor: "#627C8580",
          },
        })),
        itemStyle: {
          areaColor: "#627C8514",
          borderColor: "#3B484C",
          borderWidth: 0.5,
        },
        emphasis: {
          label: {
            show: false,
          },
          itemStyle: {
            areaColor: "#627C8580",
            opacity: 0.6,
          },
        },
        select: false,
      },
    })

    const getOption = (geo) => {
      const identifierCountriesWithCoord = identifierCountries.map(
        (country) => {
          const center = geo.getRegion(country.name)?.getCenter() || []

          return {
            ...country,
            coord: [center[0], center[1]],
          }
        },
      )

      return {
        tooltip: {
          trigger: "item",
          valueFormatter: (value) =>
            isNaN(value) ? "No IOCs" : new Intl.NumberFormat().format(value),
          confine: true,
        },
        series: [
          {
            name: "IOCs",
            type: "map",
            geoIndex: 0,
            data: identifierCountries.map(({ name, iocs }) => {
              return {
                name,
                value: iocs,
              }
            }),
            selectedMode: false,
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            silent: true,
            rippleEffect: {
              period: 4,
              scale: 6,
              number: 1,
              brushType: "stroke",
            },
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#F05252",
              borderWidth: 0,
            },
            data: identifierCountriesWithCoord.map(({ coord }) => ({
              value: coord,
            })),
          },
        ],
      }
    }

    const mapOption = getOption(
      chart.getModel().getComponent("geo").coordinateSystem,
    )
    chart.setOption(mapOption)
  }
}
